"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.credentialDefinitionFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.credentialDefinitionFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    label: `${mocks_1.orgNgb.name} Affiliations`,
    organization_id: mocks_1.orgNgb.id,
    classification_options: ['Region', 'Club'],
    credential_definition_tags: [],
    image_link_url: null,
    organization_name: mocks_1.orgNgb.name,
    image: {
        url: null,
        small_url: null,
        medium_url: null,
        large_url: null,
    },
    credential_tag_options_editable_by_user: []
});
